<template>
  <el-dialog
    title="添加附件"
    :visible.sync="dialogVisible"
    width="600"
    :before-close="dialogBeforeClose"
  >
    <el-form
      :model="form"
      label-position="top"
      label-width="150"
    >
      <el-form-item label="">
        <el-radio-group
          v-model="form.msgtype"
          @change="msgtypeChange"
        >
          <template v-for="(item, index) in msgType">
            <el-radio
              :key="index"
              :label="index"
            >
              {{ item }}
            </el-radio>
          </template>
        </el-radio-group>
      </el-form-item>

      <el-form-item
        v-if="form.msgtype !== 'image' && form.msgtype !== 'video'"
        label="标题"
      >
        <el-input
          v-model="form.title"
          placeholder="请输入内容"
          maxlength="32"
          show-word-limit
        />
      </el-form-item>

      <el-form-item
        v-if="form.msgtype !== 'video'"
        :label="form.msgtype === 'image' ? '' : '封面图'"
      >
        <MeterImage v-model="form.image" />
      </el-form-item>

      <el-form-item
        v-if="form.msgtype === 'video'"
        label=""
      >
        <MeterVideo v-model="form.video" />
      </el-form-item>
      <el-form-item
        v-if="form.msgtype === 'item'"
        label=""
      >
        <MeterGoods v-model="form.item" />
      </el-form-item>
      <el-form-item
        v-if="form.msgtype === 'coupon'"
        label=""
      >
        <MeterCoupon v-model="form.coupon" />
      </el-form-item>

      <el-form-item
        v-if="form.msgtype === 'miniprogram'"
        label="页面路径"
      >
        <el-input v-model="form.page" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible = false">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="submitForm"
      >
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import MeterImage from './comps/meterImage.vue'
import MeterVideo from './comps/meterVideo.vue'
import MeterGoods from './comps/meterGoods.vue'
import MeterCoupon from './comps/meterCoupon.vue'

export default {
  name: 'SpAttachment',
  components: {
    MeterImage,
    MeterVideo,
    MeterGoods,
    MeterCoupon
  },
  model: {
    prop: 'dialogVisible',
    event: 'dialogVisibleChange'
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        title: '',
        msgtype: 'image',
        image: null,
        video: null,
        item: null,
        coupon: null,
        page: null
      },
      msgType: {
        'image': '图片',
        'video': '视频',
        'item': '商品',
        'coupon': '优惠券',
        'miniprogram': '页面'
      },
      imageVisible: false,
      videoVisible: false
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.form = {
          title: '',
          msgtype: 'image',
          image: null,
          video: null,
          item: null,
          coupon: null,
          page: null
        }
      }
    }
  },
  methods: {
    dialogBeforeClose () {
      this.$emit('dialogVisibleChange', false)
    },
    msgtypeChange (val) {
      this.form = {
        title: '',
        image: null,
        video: null,
        item: null,
        coupon: null,
        page: null,
        msgtype: val
      }
    },
    submitForm () {
      const { msgtype, title, image, video, item, coupon, page } = this.form
      let params = {
        msgtype
      }
      if (msgtype === 'image') {
        if (!image) {
          return this.$message.error('请选择图片')
        }
        params[msgtype] = {
          title: image.image_name,
          image_url: image.image_url
        }
      } else if (msgtype === 'video') {
        if (!video) {
          return this.$message.error('请选择视频')
        }
        params[msgtype] = {
          title: video.image_name,
          video_url: video.image_url
        }
      } else if (msgtype === 'item') {
        if (!title) {
          return this.$message.error('请输入标题')
        } else if (!image) {
          return this.$message.error('请选择图片')
        } else if (!item) {
          return this.$message.error('请选择商品')
        }
        params[msgtype] = {
          title,
          miniprogram_picurl: image.image_url,
          item_id: item.goods_bn
        }
      } else if (msgtype === 'coupon') {
        if (!title) {
          return this.$message.error('请输入标题')
        } else if (!image) {
          return this.$message.error('请选择图片')
        } else if (!coupon) {
          return this.$message.error('请选择优惠券')
        }
        params[msgtype] = {
          title,
          miniprogram_picurl: image.image_url,
          coupon_id: coupon.card_id
        }
      } else if (msgtype === 'miniprogram') {
        if (!title) {
          return this.$message.error('请输入标题')
        } else if (!image) {
          return this.$message.error('请选择图片')
        } else if (!page) {
          return this.$message.error('请输入页面路径')
        }
        params[msgtype] = {
          title,
          miniprogram_picurl: image.image_url,
          page
        }
      }
      console.log(this.form, '表单数据')
      this.$emit('addAttachmentData', params)
    }
  }
}
</script>

<style lang="scss" scoped></style>
